<template>
	<div>
	<v-layout row wrap>
		<v-flex sm12 md6>
			<p class="add-event-step-header mb-2 mt-2">Be the host you'll love to be...</p>
			<p class="add-event-step-sub-header">Snacks and beverages help create moments which we can pause activity and connect together.  What treats would your guests appreciate?</p>
			<p class="add-event-step-secondary-header">Things I'll provide for attendees</p>
			<choice-field-input 
				:selectionOptions="getOptionsProvisions"
				:storeSelections="getAddEventProp('provisions')"
				:storeInputs="getAddEventProp('provisionsInputs')"
				selectionProp="provisions"
				selectionInputProp="provisionsInputs"
				:mutation="getMutation"
				class="ml-2">
			</choice-field-input>
			<v-divider class="mt-3 mb-3"></v-divider>
			<p class="add-event-step-secondary-header mb-1">Space amenities available to attendees</p>
			<p class="add-event-step-sub-header mb-3">Prefilled from Location info. Please confirm availability at this event.</p>
			<v-checkbox color="link" v-model="editLocationInfo" label="Edit Space Amenities"></v-checkbox>
			<choice-field-input 
				v-show="editLocationInfo"
				:selectionOptions="getOptions"
				:storeSelections="getAddEventProp('locationInfo')"
				:storeInputs="getAddEventProp('locationInfoInputs')"
				selectionProp="locationInfo"
				selectionInputProp="locationInfoInputs"
				:mutation="getMutation"
				class="mb-4">
			</choice-field-input>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-title">A little goes a long way...</p>
					<p class="add-event-tip-content">We recommend offering coffee, tea, and snacks to your guests. Things like fresh fruit or pastries go a long way to making everyone feel welcome at your event.</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-divider class="pt-0 mt-0">
				</v-divider>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">A little goes a long way...</p>
					<p class="add-event-tip-content">We recommend offering coffee, tea, and snacks to your guests. Things like fresh fruit or pastries go a long way to making everyone feel welcome at your event.</p>
				</v-card-text>
				<v-divider>
				</v-divider>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
	locationInfoOptions,
	eventProvisionsOptions
} from '~/store/util/values'
import * as TYPE from '~/store/util/types'
import ChoiceFieldInput from '~/components/ChoiceFieldInput'
export default {
	data() {
		return {
			infoOptions: locationInfoOptions,
			locationInfo: [],
			locationInfoInputs: {},
			amenitiesOptions: eventProvisionsOptions,
			amenities: [],
			amenitiesInputs: {},
			editLocationInfo: false
		}
	},
	components: {
		ChoiceFieldInput: ChoiceFieldInput
	},
	beforeRouteLeave(to, from, next) {
		this.setAddEventValidStep(from.path)
		this.removeAddEventInvalidStep(from.path)
		next()
	},
	methods: {
		...mapActions([
			'setAddEventProp',
			'setAddLocationProp',
			'setAddEventValidStep',
			'removeAddEventInvalidStep'
		]),
		updateLocationInfo() {
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'locationInfo',
				value: this.locationInfo
			})
		},
		updateLocationInfoInput(key) {
			this.locationInfoInputs[key] = document.getElementById(key).value
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'locationInfoInputs',
				value: this.locationInfoInputs
			})
		},
		updateLocationInfoRadioInput(key, radioVal) {
			this.locationInfoInputs[key] = document.getElementById(radioVal).value
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'locationInfoInputs',
				value: this.locationInfoInputs
			})
		},
		updateProvisions() {
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'amenities',
				value: this.amenities
			})
		},
		updateProvisionsInput(key) {
			this.amenitiesInputs[key] = document.getElementById(key).value
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'amenitiesInputs',
				value: this.amenitiesInputs
			})
		},
		updateProvisionsRadioInput(key, radioVal) {
			this.amenitiesInputs[key] = document.getElementById(radioVal).value
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'amenitiesInputs',
				value: this.amenitiesInputs
			})
		},
		isSelected(value) {
			if (this.locationInfo.includes(value.value)) {
				return true
			} else if (this.amenities.includes(value.value)) {
				return true
			} else {
				if (value.type) {
					if (value.type.includes('header')) {
						return true
					}
				}
			}
		},
		getInputVal(key) {
			if (this.locationInfoInputs.hasOwnProperty(key)) {
				return this.locationInfoInputs[key]
			} else if (this.amenitiesInputs.hasOwnProperty(key)) {
				return this.amenitiesInputs[key]
			}
		}
	},
	mounted() {
		if (this.getAddEventProp('locationInfo') !== []) {
			this.locationInfo = this.getAddEventProp('locationInfo')
		}
		if (this.getAddEventProp('locationInfoInputs') !== []) {
			this.locationInfoInputs = this.getAddEventProp('locationInfoInputs')
		}
		if (this.getAddEventProp('amenities') !== []) {
			this.amenities = this.getAddEventProp('amenities')
		}
		if (this.getAddEventProp('amenitiesInputs') !== []) {
			this.amenitiesInputs = this.getAddEventProp('amenitiesInputs')
		}
	},
	computed: {
		...mapGetters(['getAddLocationProp', 'getAddEventProp']),
		getMutation() {
			return TYPE.SET_ADD_EVENT_PROP
		},
		getOptions() {
			return locationInfoOptions
		},
		getOptionsProvisions() {
			return eventProvisionsOptions
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		},
		locationInfoComputed: {
			get() {
				return this.locationInfo
			},
			set(val) {
				this.locationInfo = val
			}
		},
		amenitiesComputed: {
			get() {
				return this.amenities
			},
			set(val) {
				this.amenities = val
			}
		}
	}
}
</script>
